import React, { useState } from "react";
import "./App.css";

export default function ParaphraseForm() {
  const [inputText, setInputText] = useState("");
  const [paraphrased, setParaphrased] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleParaphrase = async () => {
    setLoading(true);
    setParaphrased("");
    setError("");
    try {
      const response = await fetch("/api/paraphrase", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ inputText }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || `Request failed (${response.status}).`);
        return;
      }

      setParaphrased(data.paraphrased || "No response received.");
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="paraphrase-page">
      <div className="paraphrase-card">
        <h2 className="paraphrase-title">🩺 Patient Observation Paraphraser</h2>

        <textarea
          rows={6}
          className="paraphrase-input"
          placeholder="Enter your observation notes here..."
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
        />

        <div className="paraphrase-actions">
          <button
            className="paraphrase-button"
            onClick={handleParaphrase}
            disabled={loading || !inputText.trim()}
          >
            {loading ? "Paraphrasing..." : "Paraphrase"}
          </button>
        </div>

        {error && <div className="paraphrase-error">{error}</div>}

        {paraphrased && (
          <div className="paraphrase-result">
            <h3 className="paraphrase-result-title">📝 Paraphrased Summary</h3>
            <p className="paraphrase-result-text">{paraphrased}</p>
          </div>
        )}
      </div>
    </div>
  );
}
